
import React, { useState, useEffect } from 'react'
import axios from 'axios';
import {baseUrl, animalType} from "../../comman/config.js";
import Loader from "../../comman/Loader";


function Dashboard() {

    const [notificationList, setNotificationList] = useState([]);
    const [popupOpen, setPopupOpen] = useState(false);


    useEffect(() => {
        getNotificationList();
    }, []);
    

    const getNotificationList = async () => {
        setPopupOpen(true);
        const response = await axios.get(`${baseUrl}/admin/dashboard/notification`);
        setPopupOpen(false);
        setNotificationList(response.data.data);
    }

    const getDateList = (datelist) => {

        const currentDate = new Date();

        // Format the date as YYYY-MM-DD
        const formattedDate = currentDate.toISOString().split('T')[0];

        const dateList = JSON.parse(datelist);
        return dateList.filter((val) => val != formattedDate).map((val) => val).join(", ");
    }
    
    return (
        
        <div className="p-4">
            {popupOpen && (
                     <Loader /> 
                ) }
            <div className="flex justify-between items-center py-4 px-6">
                <h1 className="text-lg sm:text-xl md:text-xl lg:text-xl xl:text-2xl font-bold">Dashboard</h1>
              
            </div>
            
            <div className="relative overflow-x-auto ">
                <div className="flex justify-between">
                    <div className="w-full sm:w-1/3 p-2">
                        <a href="/admin/farm/dashboard" className="block bg-blue-500 text-white p-4 rounded-lg shadow-lg hover:bg-blue-600 transition duration-200">
                            <h2 className="font-bold text-xl">Farm</h2>
                            <p>Your content for card 1 goes here.</p>
                        </a>
                    </div>

                    {/* Card 2 */}
                    <div className="w-full sm:w-1/3 p-2">
                    <a href="/admin/agriculture/dashboard" className="block bg-blue-500 text-white p-4 rounded-lg shadow-lg hover:bg-blue-600 transition duration-200">
                            <h2 className="font-bold text-xl">Agriculture</h2>
                            <p>Your content for card 1 goes here.</p>
                        </a>
                    </div>

                    {/* Card 3 */}
                    <div className="w-full sm:w-1/3 p-2">
                        <a href="/admin/construction/dashboard" className="block bg-blue-500 text-white p-4 rounded-lg shadow-lg hover:bg-blue-600 transition duration-200">
                            <h2 className="font-bold text-xl">Construction</h2>
                            <p>Your content for card 1 goes here.</p>
                        </a>
                    </div>
                </div>
                
            </div>
            <div className="py-10">
                <div className="bg-white border rounded-lg shadow p-4 dark:bg-gray-800 dark:border-gray-700">
                    <strong>Notification</strong>
                    <table className="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400 mt-2">
                        <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                            <tr>
                                <th scope="col" className="px-6 py-3 border">Date</th>
                                <th scope="col" className="px-6 py-3 border">Future Date List</th>
                                <th scope="col" className="px-6 py-3 border">Animal Type</th>
                                <th scope="col" className="px-6 py-3 border">Animal Id</th>
                                <th scope="col" className="px-6 py-3 border">Shed No.</th>
                                <th scope="col" className="px-6 py-3 border">Description</th>

                            </tr>
                        </thead>
                        <tbody>
                            {notificationList.map((item, index) => (
                                <tr key={index} className="bg-white border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600">
                                    <th className="px-6 py-4">{new Date().toISOString().split('T')[0]}</th>
                                    <th className="px-6 py-4">{getDateList(item.date)}</th>
                                    <th className="px-6 py-4">{animalType.find((val) => val.value ==item.animal_type)?.label ?? ""}</th>
                                    <td className="px-6 py-4">{item.animal_id}</td>
                                    <td className="px-6 py-4">{item.shed_no}</td> 
                                    <td className="px-6 py-4">{item.description}</td> 

                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        
  );
}

export default Dashboard;